module.exports = __webpack_public_path__ + "43639a26a8598da0ab7d218f4e92a28d.png";